import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';

const DealPaymentBankDetails: React.FC = () => {
    const bankAccount = useSelector((state: RootState) => state.dealPayment.payment?.deal.bankAccount);

    const address = useMemo(() => {
        let address = '';
        if (bankAccount) {
            if (bankAccount.beneficiaryBank) {
                if (bankAccount.beneficiaryBank.address) {
                    address = bankAccount.beneficiaryBank.address.address1 || '';
                    if (bankAccount.beneficiaryBank.address.address2) {
                        address = `${address}, ${bankAccount.beneficiaryBank.address.address2}`;
                    }
                    if (bankAccount.beneficiaryBank.address.country) {
                        address = `${address}, ${bankAccount.beneficiaryBank.address.country}, ${bankAccount.beneficiaryBank.address.postalCode}`;
                    }
                }
            }
        }
        return address;
    }, [bankAccount]);

    const intermediaryAddress = useMemo(() => {
        let address = '';
        if (bankAccount) {
            if (bankAccount.intermediaryBank) {
                if (bankAccount.intermediaryBank.address) {
                    address = bankAccount.intermediaryBank.address.address1 || '';
                    if (bankAccount.intermediaryBank.address.address2) {
                        address = `${address}, ${bankAccount.intermediaryBank.address.address2}`;
                    }
                    if (bankAccount.intermediaryBank.address.country) {
                        address = `${address}, ${bankAccount.intermediaryBank.address.country}, ${bankAccount.intermediaryBank.address.postalCode}`;
                    }
                }
            }
        }
        return address;
    }, [bankAccount]);

    return (
        <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto">
            <div className="px-4 py-4 divide-y-2">
                {bankAccount && bankAccount.accountName && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Name :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.accountName}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.accountNumber && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Bank A/C Number :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.accountNumber}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.beneficiaryBank && bankAccount.beneficiaryBank.bankName && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Bank :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.beneficiaryBank.bankName}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.beneficiaryBank && bankAccount.beneficiaryBank.bankCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Bank Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.beneficiaryBank.bankCode}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.beneficiaryBank && bankAccount.beneficiaryBank.branchCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Branch Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.beneficiaryBank.branchCode}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.beneficiaryBank && bankAccount.beneficiaryBank.swiftCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Bank Swift Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.beneficiaryBank.swiftCode}
                            </p>
                        </div>
                    </div>
                )}

                {address && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Beneficiary Bank Address :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {address}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.intermediaryBank && bankAccount.intermediaryBank.bankName && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Intermediary Bank Name :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.intermediaryBank.bankName}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.intermediaryBank && bankAccount.intermediaryBank.bankCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Intermediary Bank Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.intermediaryBank.bankCode}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.intermediaryBank && bankAccount.intermediaryBank.branchCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Intermediary Branch Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.intermediaryBank.branchCode}
                            </p>
                        </div>
                    </div>
                )}

                {bankAccount && bankAccount.intermediaryBank && bankAccount.intermediaryBank.swiftCode && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Intermediary Bank Swift Code :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {bankAccount.intermediaryBank.swiftCode}
                            </p>
                        </div>
                    </div>
                )}

                {intermediaryAddress && (
                    <div className="flex py-2">
                        <div className="w-8/12">
                            <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                                Intermediary Bank Address :
                            </p>
                        </div>
                        <div className="w-4/12 text-right">
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {intermediaryAddress}
                            </p>
                        </div>
                    </div>
                )}

                <div className="flex py-2">
                    <div className="w-4/12">
                        <p className="text-base" style={{ color: 'rgb(118, 129, 135)' }}>
                            Reference :{' '}
                        </p>
                    </div>
                    <div className="w-8/12 text-right">
                        <p className="text-base" style={{ color: '#c49a6d' }}>
                            {`<Payee & Deal Name>`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DealPaymentBankDetails;
